import React from 'react';
import { bindActionCreators } from 'redux';
import AlfredSearchResult from './AlfredSearchResult';
import ChatWindow from './AlfredSuggestions'
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAlfredQuestions } from '../../actions/index'
class Alfred extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Intent: [],
      charts: [],
      questions: [],
    }
    this.props.getAlfredQuestions(this.props.dataSet, this.props.authData)
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps)
  }
  componentDidUpdate() {
    // jQuery(".active").removeClass("active");
    jQuery("#liSearch").addClass("active");
  }
  render() {
    var variable = {
      data: {
        Intent: this.props.intent,
        charts: this.props.chart,
        questions: this.props.questions
      },
      type: 'text',
      alfredQuestion: ""
    };
    return (
        <Switch>
          <Route exact path={`${this.props.match.url}`} render={() => <ChatWindow data={variable} />} />
          <Route path={`${this.props.match.url}/SearchResult`} component={AlfredSearchResult} />
        </Switch>
    )
  }
}
function mapStateToProps(state) {
  return {
    // dataSet: state.dataSet.dataResult[0],
    dataSet: JSON.parse(localStorage.Dataset),
    authData: state.dataSet.authData,
    intent: state.alfred.intent,
    questions: state.alfred.questions,
    chart: state.alfred.chart_array,
    metric: state.alfred.metric    
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getAlfredQuestions
  }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Alfred)